import React from 'react';
import Layout from '@/Shared/Layout';
import { InertiaLink, useForm, usePage } from '@inertiajs/inertia-react';
import DeleteButton from '@/Shared/DeleteButton';
import LoadingButton from '@/Shared/LoadingButton';
import BannerForm from '@/Pages/Banners/Assets/BannerForm';
import { Inertia } from '@inertiajs/inertia';

const Edit = () => {
  const {banner} = usePage().props;

  const {data, setData, errors, post, processing} = useForm({
    url: banner.url || '',
    image: '',
    mob_image: '',
    showonline: banner.showonline || false,
    banner_name: banner.banner_name || '',
    expire_date: banner.expire_date || ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('banners.update', banner.id).url());
  }

  function destroy() {
    if (confirm('Are you sure you want to delete this banner?')) {
      Inertia.delete(route('banners.destroy', banner.id));
    }
  }


  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('banners')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Banners
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <BannerForm errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-between px-8 py-4 bg-gray-100 border-t border-gray-200">
            <DeleteButton onDelete={destroy}>Delete Banner</DeleteButton>
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Banner
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit banner" children={page}/>;
export default Edit;
